var exports = {
  "k": "x0a7806d5--449bec--container",
  "n": "x0a7806d5--449bec--link",
};

module.exports = exports;
